import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../auth/auth.store';
import { AuthService } from '../auth/auth.service';

export type UserRole = 'EMPRESA' | 'PROFISSIONAL';

/**
 * Factory for a guard that requires a specific role. If the user is
 * authenticated but with the wrong role, bounce them to their own shell
 * (NOT /welcome — they're already logged in).
 */
export const roleGuard =
  (allowed: UserRole): CanActivateFn =>
  async () => {
    const authStore = inject(AuthStore);
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authStore.isAuthenticated()) {
      await authService.refresh();
    }

    if (authStore.role() === allowed) return true;
    return router.parseUrl(authStore.shellPath());
  };
